interface TruncateOptions {
  startChars?: number
  endChars?: number
  separator?: string
  minLength?: number
}

export function truncateHash(hash: string, options: TruncateOptions = {}): string {
  const { startChars = 6, endChars = 4, separator = '...', minLength = 10 } = options

  if (!hash || hash.length <= minLength) {
    return hash
  }

  return `${hash.slice(0, startChars)}${separator}${hash.slice(-endChars)}`
}
